export default "__VITE_PUBLIC_ASSET__fdacf1af__"